import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from "lodash";
import { Request } from "./request";
import { URLS } from "../constants/url.constants";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class DocumentService {
  constructor(
    private request: Request,
    private http: HttpClient,
  ) {
  }

  uploadAvatar(values): Observable<any> {
    let url = URLS.document.uploadAvatar;
    return this.request.postApi(url, values);
  }

  uploadFilesToS3Bucket(url, blob): Observable<any> {
    return this.request.awsFilePut(url, blob);
  }

  getFileUrl(path: string): Observable<any> {
    let url = URLS.document.getFilePath + '?path=' + path;
    return this.request.getApi(url);
  }


}
